import { render } from "./ListeTypeNotification.vue?vue&type=template&id=484df09a&ts=true"
import script from "./ListeTypeNotification.vue?vue&type=script&lang=ts"
export * from "./ListeTypeNotification.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__